/**
 * Was getting "Declaration emit for this file requires using private name".
 * This `type` annotation is a workaround. See: https://stackoverflow.com/questions/60009092/declaration-will-not-emit-due-to-private-name-usage
 * @type {unknown}
 */
const ParserState = function(text, pos, data) {
	this.text = text;
	this.pos = pos || 0;
	this.data = data || {};

	this.parseNonmath = this.data.parseNonmath;
	this.parseMath = this.data.parseMath;

	this.errors = [];
	this.ignoreErrors = false;
	this.parentOffset = 0;
	this.parentPs = null;
};

// Static
ParserState.convert = function(textOrParser) {
	return typeof textOrParser !== "object"
		? new ParserState(textOrParser || "")
		: textOrParser;
};

ParserState.prototype.replace = function() {
	return this.pos >= this.text.length;
};

ParserState.prototype.done = function() {
	return this.pos >= this.text.length;
};

ParserState.prototype.at = function(pos) {
	const newPS = this.clone();
	newPS.pos = pos;
	return newPS;
};

ParserState.prototype.upTo = function(endPos) {
	return this.withText(this.text.slice(0, endPos), this.pos);
};

ParserState.prototype.getRest = function() {
	return this.text.slice(this.pos);
};

ParserState.prototype.setRest = function(text) {
	this.text = this.text.slice(0, this.pos) + text;
	return this; // Chaining
};

ParserState.prototype.withText = function(text, pos) {
	const newPS = this.clone();
	newPS.text = text;
	newPS.pos = pos || 0;
	return newPS;
};

// Clones parser and treats original as parent. Does not bring over errors or
// error piping; set that manually.
ParserState.prototype.clone = function() {
	const newState = new ParserState(this.text, this.pos, this.data);
	newState.parentPs = this;
	newState.parseNonmath = this.parseNonmath;
	newState.parseMath = this.parseMath;
	return newState;
};

ParserState.prototype.pushError = function(message, pos) {
	if (this.ignoreErrors) {
		return this; // For chaining
	}
	pos = pos === undefined ? this.pos : pos;
	this.errors.push({
		message: message,
		pos: pos,
	});

	if (this.parentPs) {
		this.parentPs.pushError(message, pos + (this.parentOffset || 0));
	}
	return this; // For chaining
};

ParserState.prototype.mergeErrorsAt = function(offset) {
	if (!this.parentPs) {
		return this; // Nothing to merge errors into.
	}

	let newErrors = this.errors;
	if (offset) {
		newErrors = this.errors.map(function(error) {
			return {
				message: error.message,
				pos: error.pos + offset,
			};
		});
	}
	this.parentPs.errors = this.parentPs.errors.concat(newErrors);
	return this; // For chaining
};

ParserState.prototype.pipeErrorsAt = function(offset) {
	if (!this.parentPs) {
		return this; // Nothing to merge errors into.
	}

	this.parentOffset = offset || 0;
	if (this.errors.length) {
		this.mergeErrorsAt(offset);
	}
	return this; // For chaining
};

ParserState.prototype.setIgnoreErrors = function(newVal) {
	this.ignoreErrors = !!newVal;
	return this; // For chaining
};

// Debugging
ParserState.prototype.dump = function() {
	return (
		'"' +
		this.text.slice(this.pos) +
		'" ' +
		this.pos +
		". " +
		JSON.stringify(this.errors)
	);
};

module.exports = ParserState;
